import React, { useState } from 'react';
import { Form, FormGroup, Label, Input, Col, Button, Card, CardBody, CardHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import { SelectNet } from "../BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "../BasicComponents/SelectUnitproxyApply";
import { ReactSelectUnitproxyApply } from "../BasicComponents/reactSelectUnitproxyApply";

import SelectReport from "../BasicComponents/SelectReport";
import SelectUrlTKBG from "../BasicComponents/SelectUrlTKBG";
import { api_url } from "../globalFunction/global_string";
import { FaTrash } from 'react-icons/fa';
import withReactContent from 'sweetalert2-react-content';

const riskLevelMapping = {
    '高': 4,
    '中': 3,
    '低': 2,
    '資訊': 1
};
function CreateWAFList() {
    const [formValues, setFormValues] = useState({
        projectName: '',
        projectStartTime: '',
        projectEndTime: '',
        riskLevels: [4, 3], // 預設選中"高"和"中"
        selectedDuration: '1',
        isSubmitted: false
    });

    const MySwal = withReactContent(Swal);

    const [selectnet, setSelectnet] = useState("");
    const [local_net_name, setLocal_net_name] = useState("");
    const [selectUnit, setSelectUnit] = useState("");
    const [local_unit_name, setLocal_unit_name] = useState("");
    const [selecturl, setSelectUrl] = useState("");
    const [local_Url_name, setLocal_Url_name] = useState("");
    const [selectreport, setSelectreport] = useState("");
    const [local_report_name, setLocal_report_name] = useState("");
    const [trackingReports, setTrackingReports] = useState([
        {
            SEQ: 1,
            selectNet: '',
            selectUnit: '',
            selectUrl: '',
            selectReport: '',
            local_net_name: '',
            local_unit_name: '',
            local_Url_name: '',
            local_report_name: '',
            selectedDuration: '1'
        }
    ]);

    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    const unit_name = localStorage.getItem('login_local_unit_name');


    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // 檢查結束時間是否小於開始時間
        if (name === 'projectEndTime' && new Date(value) < new Date(formValues.projectStartTime)) {
            Swal.fire({
                title: '錯誤!',
                text: '追蹤計畫結束時間不能小於開始時間',
                icon: 'error',
                confirmButtonText: '好的'
            });
            return;
        }

        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const handleRiskLevelChange = (event) => {
        const { value } = event.target;
        const numValue = riskLevelMapping[value];
        setFormValues(prevValues => ({
            ...prevValues,
            riskLevels: prevValues.riskLevels.includes(numValue)
                ? prevValues.riskLevels.filter(level => level !== numValue)
                : [...prevValues.riskLevels, numValue].sort((a, b) => a - b)
        }));
    };

    // 處理網域選擇
    const handleNetSelectChange = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectNet: data.value,
            local_net_name: data.selectedName,
            selectUnit: '',
            local_unit_name: '',
            selectUrl: '',
            local_Url_name: '',
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理單位選擇
    const selectUnitproxyApply = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectUnit: data.value,
            local_unit_name: data.selectedName,
            selectUrl: '',
            local_Url_name: '',
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理報告選擇
    const handleUrlChange = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectUrl: data.value,
            local_Url_name: data.selectedName,
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理報告選擇
    const selectReport = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectReport: data.value,
            local_report_name: data.selectedName
        };
        setTrackingReports(newReports);
    };


    //報告時間
    const durationOptions = [
        { label: '1個月', value: '1' },
        { label: '3個月', value: '3' },
        { label: '6個月', value: '6' },
        { label: '一年', value: '12' },
        { label: '二年', value: '24' },
        { label: '三年', value: '36' },
    ];

    // 處理報告風險數
    const handleDurationChange = (event) => {
        setFormValues(prevValues => ({
            ...prevValues,
            selectedDuration: event.target.value
        }));
    };


    // 新增追蹤報告
    const addTrackingReport = () => {
        setTrackingReports(prevReports => [
            ...prevReports,
            {
                SEQ: prevReports.length > 0
                    ? Math.max(...prevReports.map(r => r.SEQ || 0)) + 1  // 避免 null
                    : 1, // 確保 SEQ 從 1 開始
                selectNet: '',
                selectUnit: '',
                selectUrl: '',
                selectReport: '',
                local_net_name: '',
                local_unit_name: '',
                local_Url_name: '',
                local_report_name: '',
                selectedDuration: '1'
            }
        ]);
    };


    // 更新指定追蹤報告的資料
    const updateTrackingReport = (index, field, value) => {
        const updatedReports = trackingReports.map((report, i) => {
            if (i === index) {
                return { ...report, [field]: value };
            }
            return report;
        });
        setTrackingReports(updatedReports);
    };
    const removeTrackingReport = (index) => {
        setTrackingReports(prevReports =>
            prevReports
                .filter((_, i) => i !== index) // 先移除指定的索引
                .map((report, newIndex) => ({ ...report, SEQ: newIndex + 1 })) // 重新計算 SEQ
        );
    };



    const handleSave = async () => {
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }
        if (trackingReports.length === 0 || trackingReports.some(report => report.selectUrl.trim() === '')) {
            Swal.fire('錯誤', '請至少新增一個追蹤網站', 'error');
            return;
        }
        let apiUrl = api_url + '/api/TrackBackground/PostWAFBackgroundlist';
        let currentDateTime = new Date().toISOString();
        const selectUrlSet = new Set();

        for (const report of trackingReports) {
            console.log(report);
            const unitUrlCombo = report.selectUnit + '|' + report.selectUrl;

            if (selectUrlSet.has(unitUrlCombo)) {
                Swal.fire('錯誤', '追蹤WAF網站中有重複的單位網站', 'error');
                return;
            }
            if (!report.selectUnit || !report.selectUrl) {
                Swal.fire('錯誤', '您有一個或多個下拉選單未選擇', 'error');
                return;
            }
            selectUrlSet.add(unitUrlCombo);
        }
        let allReportsSubmittedSuccessfully = true;
        console.log("Tracking Reports:", trackingReports);
        for (const report of trackingReports) {
            const formData = new FormData();
            formData.set('SEQ', report.SEQ);
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);

            formData.set('projectTemporarilySave', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));
            if (userType === 'S') {
                formData.set('IsadminbuildWAF', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildWAF', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildWAF', 'true');
            }
            if (userType === 'S') {
                formData.set('IsadminWAF', 'true');
                formData.set('IsNetWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            } else if (userType === 'M') {
                formData.set('IsNetWAF', 'true');
                formData.set('IsadminWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            } else if (userType === 'N') {
                formData.set('IsUnitWAF', 'true');
                formData.set('IsNetWAF', 'false');
                formData.set('IsadminWAF', 'false');
            } else {
                formData.set('IsadminWAF', 'false');
                formData.set('IsNetWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            }
            for (const key in report) {
                formData.append(key, report[key]);
            }
            MySwal.fire({
                title: '處理中...',
                text: '網站建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode)
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }
        }

        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤網站儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }

        let confirmSubmit = false;

        confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => {
            return result.isConfirmed
        });

        if (!confirmSubmit) {
            return;
        }
        let apiUrl = api_url + '/api/TrackBackground/PostWAFBackgroundlist';
        let currentDateTime = new Date().toISOString();
        const selectUrlSet = new Set();

        for (const report of trackingReports) {
            console.log(report.id)
            if (selectUrlSet.has(report.selectUrl)) {
                Swal.fire('錯誤', '追蹤網站中有重複的網站', 'error');
                return;
            }
            selectUrlSet.add(report.selectUrl);
        }
        let allReportsSubmittedSuccessfully = true;
        for (const report of trackingReports) {
            const formData = new FormData();
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);


            formData.set('projectStore', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));
            if (userType === 'S') {
                formData.set('IsadminbuildWAF', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildWAF', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildWAF', 'true');
            }
            if (userType === 'S') {
                formData.set('IsadminWAF', 'true');
                formData.set('IsNetWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            } else if (userType === 'M') {
                formData.set('IsNetWAF', 'true');
                formData.set('IsadminWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            } else if (userType === 'N') {
                formData.set('IsUnitWAF', 'true');
                formData.set('IsNetWAF', 'false');
                formData.set('IsadminWAF', 'false');
            } else {
                formData.set('IsadminWAF', 'false');
                formData.set('IsNetWAF', 'false');
                formData.set('IsUnitWAF', 'false');
            }
            MySwal.fire({
                title: '處理中...',
                text: '報告建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            for (const key in report) {
                formData.append(key, report[key]);
            }

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode)
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }

        }
        MySwal.close();


        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤網站儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };

    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }

    const renderTrackingReportForms = () => {
        return [...trackingReports].sort((a, b) => a.SEQ - b.SEQ).map((report, index) => (
            <Card key={report.SEQ}>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    追蹤網站 #{index + 1}
                    {index > 0 && (
                        <Button color="danger" onClick={() => removeTrackingReport(index)}>
                            <FaTrash />
                        </Button>
                    )}
                </CardHeader>
                <CardBody>
                    {renderFormDataUsertype(report, index)}
                </CardBody>
            </Card>
        ));
    };


    const renderFormDataUsertype = (report, index) => {
        if (userType === 'S') {
            return (
                <>
                    <FormGroup row>
                        <Label for={`local_net_id_${index}`} sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <SelectNet
                                parentName={`superS`}
                                id={`excel_net_name_${index}`}
                                name={`excel_net_name_${index}`}
                                requiredAPI={'/api/JRCC/GetLocalNetId'}
                                handleNetSelectChange={(data) => handleNetSelectChange(data, index)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <ReactSelectUnitproxyApply
                                parentName={'superS'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                SelectUnitproxyApply={(data) => selectUnitproxyApply(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superSTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetWAFUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        } else if (userType === 'M') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <ReactSelectUnitproxyApply
                                parentName={'superM'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                SelectUnitproxyApply={(data) => selectUnitproxyApply(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superMTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetWAFUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                            />
                        </Col>
                    </FormGroup>
                </>)
        } else {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{unit_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superNTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetWAFUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}
                            />
                        </Col>
                    </FormGroup>
                </>
            )
        }
    }
    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <FormGroup row>
                    <Label for="projectName" sm={2}>追蹤計畫名稱:</Label>
                    <Col sm={10}>
                        <Input
                            type="text"
                            name="projectName"
                            id="projectName"
                            value={formValues.projectName}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectStartTime" sm={2}>追蹤計畫開始時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectStartTime"
                            id="projectStartTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectStartTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectEndTime" sm={2}>追蹤計畫結束時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectEndTime"
                            id="projectEndTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectEndTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                {renderTrackingReportForms()}
                <Button onClick={addTrackingReport} color="success">新增追蹤網站</Button>
                {' '}
                <Button onClick={handleSave} color="secondary" >
                    儲存
                </Button>
                {' '}
                {/* <Button type="submit" color="primary" >
                    提交
                </Button> */}
            </Form>


        </div>
    );
}

export default CreateWAFList;
